// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.victory-panel-shell {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 65dvw;
  height: 80dvh;
  transform: translate(-50%, -50%);
  z-index: 9000;
  pointer-events: auto;
}

.victory-panel-card {
  position: relative;
  display: grid;
  grid-template-columns: minmax(280px, 0.92fr) minmax(360px, 1.18fr);
  width: 100%;
  height: 100%;
  padding: 24px;
  border-radius: 30px;
  border: 5px solid rgba(255, 255, 255, 0.28);
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(235, 240, 255, 0.94)),
    radial-gradient(circle at top left, rgba(92, 198, 208, 0.18), transparent 34%);
  box-shadow:
    0 24px 60px rgba(0, 0, 0, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.65);
  animation: victoryPanelSlideIn 0.8s ease-out;
  gap: 24px;
  overflow-y: auto;
}

.victory-panel-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 18px;
  border-radius: 24px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.92), rgba(239, 244, 255, 0.82)),
    radial-gradient(circle at top, rgba(236, 98, 255, 0.12), transparent 40%);
  box-shadow: inset 0 0 0 1px rgba(105, 41, 252, 0.08);
  min-width: 0;
}

.victory-panel-image-wrap {
  margin-bottom: 18px;
  animation: victoryPanelImageBounce 1s ease-in-out infinite alternate;
}

.victory-panel-image {
  /* width: min(18vw, 250px); */
  min-width: 120px;
  height: auto;
  display: block;
  filter: drop-shadow(0 12px 24px rgba(0, 0, 0, 0.3));
}

.victory-panel-title {
  margin: 10px 0 16px;
  color: var(--jedi-violet);
  font-size: clamp(2rem, 3.5vw, 4rem);
  font-weight: 900;
  line-height: 1;
  text-align: center;
  text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.28);
  animation: victoryPanelTitlePulse 1.5s ease-in-out infinite;
}

.victory-panel-subtitle {
  max-width: 18ch;
  margin: 0 0 18px;
  color: #334155;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.35;
  text-align: center;
}

.victory-panel-ranking-type {
  color: var(--jedi-violet);
  font-size: 1.0rem;
  font-weight: 700;
  font-family: Comic Sans MS, Comic Sans, cursive;
  line-height: 1.35;
  text-align: center;
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 18px;
  background: linear-gradient(180deg, var(--jedi-green) 0%, var(--jedi-dark-green) 150%);
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #647e0d;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  &:hover {
    background-color: #647e0d;
    color: #fff;
  }
}

.victory-panel-restart-button {
  margin-top: 12px;
  padding: 18px 42px;
  border: none;
  border-radius: 999px;
  color: #fff;
  font-size: clamp(1rem, 1.6vw, 1.35rem);
  font-weight: 800;
  cursor: pointer;
  background: linear-gradient(135deg, var(--jedi-green) 0%, var(--jedi-dark-green) 100%);
  box-shadow:
    0 10px 30px rgba(0, 0, 0, 0.22),
    inset 0 1px 0 rgba(255, 255, 255, 0.28);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.victory-panel-restart-button:hover {
  transform: scale(1.05);
  box-shadow:
    0 14px 36px rgba(0, 0, 0, 0.28),
    inset 0 1px 0 rgba(255, 255, 255, 0.28);
}

.victory-panel-restart-button:active {
  transform: scale(0.97);
}

.victory-ranking {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-width: 0;
  min-height: 0;
/*  border-radius: 24px;
  padding: 18px 18px 14px;
  background: linear-gradient(180deg, rgba(248, 250, 255, 0.96), rgba(237, 242, 255, 0.94));
  box-shadow:
    inset 0 0 0 1px rgba(92, 198, 208, 0.18),
    0 10px 24px rgba(54, 78, 135, 0.08);
  overflow: hidden;*/
}

.victory-ranking-scale-shell {
  position: relative;
  flex: 1 1;
  min-width: 0;
  min-height: 0;
}

.victory-ranking-scale-stage {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 620px;
  height: auto;
  display: flex;
  flex-direction: column;
  transform-origin: center center;
}

.victory-ranking-header {
  flex-shrink: 0;
  margin-bottom: 14px;
}

.victory-ranking-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  color: var(--jedi-violet);
  font-size: clamp(1.4rem, 2vw, 2rem);
  font-weight: 900;
}

.victory-ranking-title-icon {
  font-size: 1.1em;
  line-height: 1;
}

.victory-ranking-accent {
  width: 84px;
  height: 6px;
  margin-top: 10px;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--jedi-pink), var(--jedi-blue));
  box-shadow: 0 0 12px rgba(236, 98, 255, 0.32);
}

.victory-ranking-board {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  min-height: 0;
  border-radius: 22px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.6);
  border: 2px solid rgba(105, 41, 252, 0.08);
}

.victory-ranking-grid {
  display: grid;
  grid-template-columns: 6fr 6fr 30fr 9fr;
  align-items: center;
  gap: 8px;
}

.victory-ranking-head {
  padding: 14px 16px;
  color: white;
  background: linear-gradient(135deg, var(--jedi-violet), #4c1ab1);
  font-size: 1.5rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.14);
}

.victory-ranking-body {
  min-height: 0;
  flex: 1 1;
  overflow-y: auto;
  padding: 6px 8px;
}

.victory-ranking-body::-webkit-scrollbar {
  width: 8px;
}

.victory-ranking-body::-webkit-scrollbar-track {
  background: rgba(105, 41, 252, 0.08);
  border-radius: 999px;
}

.victory-ranking-body::-webkit-scrollbar-thumb {
  background: rgba(105, 41, 252, 0.46);
  border-radius: 999px;
}

.victory-ranking-row {
  padding: 10px 8px;
  color: #334155;
  border-bottom: 1px solid rgba(148, 163, 184, 0.18);
  transition: background-color 0.15s ease;
}

.victory-ranking-row:hover {
  background: rgba(255, 255, 255, 0.78);
}

.victory-ranking-row.is-top-three .victory-ranking-position {
  color: var(--jedi-violet);
  font-weight: 900;
}

.victory-ranking-row.is-current-player-duplicate {
  background:
    linear-gradient(90deg, rgba(196, 222, 29, 0.16), rgba(92, 198, 208, 0.08));
  box-shadow:
    inset 4px 0 0 rgba(196, 222, 29, 0.9),
    inset 0 0 0 1px rgba(196, 222, 29, 0.18);
}

.victory-ranking-row.is-current-player-duplicate:hover {
  background:
    linear-gradient(90deg, rgba(196, 222, 29, 0.22), rgba(92, 198, 208, 0.12));
}

.victory-ranking-row.is-placeholder {
  color: #94a3b8;
  font-style: italic;
}

.victory-ranking-row.is-placeholder:hover {
  background: transparent;
}

.victory-ranking-player-row {
  padding: 12px 16px;
  color: white;
  background: linear-gradient(135deg, var(--jedi-violet), #4c1ab1);
  box-shadow: 0 -6px 18px rgba(76, 26, 177, 0.18);
}

.victory-ranking-cell-center {
  text-align: center;
}

.victory-ranking-cell-score {
  text-align: right;
  font-weight: 900;
  font-size: 1.5rem;
}

.victory-ranking-position {
  font-size: 1.8rem;
  font-weight: 800;
}

.victory-ranking-name {
  display: grid;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 800;
  font-size: 1.8rem;
  line-height: 1.2;
}

/* Linha 1: nome + etiqueta da turma (+ "você") */
.victory-ranking-name-main {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.victory-ranking-name-text {
  flex: none;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Turma em etiqueta: textos longos (ex.: "NEM EPT IF TEC...") são cortados só aqui; o texto completo fica no title */
.victory-ranking-turma {
  min-width: 0;
  max-width: 11em;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 1px 9px;
  border-radius: 999px;
  background: rgba(92, 198, 208, 0.18);
  color: #0e6670;
  font-size: 0.95rem;
  font-weight: 700;
}

/* Linha 2: apelido · escola */
.victory-ranking-name-sub {
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 1.05rem;
  font-weight: 600;
  color: #64748b;
}

.victory-ranking-player-row .victory-ranking-turma {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
}

.victory-ranking-player-row .victory-ranking-name-sub {
  color: rgba(255, 255, 255, 0.82);
}

.victory-ranking-name-main .victory-ranking-player-label {
  flex: none;
  margin-left: 0;
}

.victory-ranking-player-label {
  margin-left: 8px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  opacity: 0.92;
}

.victory-ranking-avatar-wrap {
  display: flex;
  justify-content: center;
}

.victory-ranking-avatar-button {
  padding: 0;
  border: none;
  background: transparent;
  border-radius: 999px;
  cursor: pointer;
  transition: transform 0.15s ease;
}

.victory-ranking-avatar-button:hover,
.victory-ranking-avatar-button:focus-visible {
  transform: scale(1.06);
}

.victory-ranking-avatar-button:focus-visible {
  outline: 3px solid rgba(92, 198, 208, 0.5);
  outline-offset: 2px;
}

.victory-ranking-avatar {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 999px;
  /* border: 2px solid rgba(92, 198, 208, 0.82); */
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.14),
    inset 0 0 0 1px rgba(255, 255, 255, 0.24);
}

/* Avatar que não carregou: círculo com a inicial */
.victory-ranking-avatar-fallback {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #7c3aed 0%, #5cc6d0 100%);
  color: #fff;
  font-weight: bold;
  font-size: 1.1rem;
}

.victory-panel-avatar-overlay {
  position: absolute;
  inset: 0;
  z-index: 30;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.victory-panel-avatar-overlay.is-visible {
  opacity: 1;
}

.victory-panel-avatar-overlay-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.18);
  backdrop-filter: blur(1.5px);
}

.victory-panel-avatar-overlay-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.victory-panel-avatar-overlay-card {
  width: clamp(180px, 18vw, 250px);
  aspect-ratio: 752 / 926;
  overflow: hidden;
  border: 4px solid rgba(255, 255, 255, 0.9);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow:
    0 24px 80px rgba(0, 0, 0, 0.45),
    0 0 0 1px rgba(226, 232, 240, 0.8);
  padding: 8px;
}

.victory-panel-avatar-overlay-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
  border-radius: 12px;
}

.victory-ranking-player-row .victory-ranking-avatar {
  border-color: rgba(255, 255, 255, 0.95);
}

.victory-ranking-loading {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  padding: 18px 12px;
}

.victory-ranking-loading-text {
  color: var(--jedi-violet);
  font-size: 1rem;
  font-weight: 900;
  text-align: center;
}

.victory-ranking-loading-orbs {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.victory-ranking-loading-orb {
  width: 14px;
  height: 14px;
  border-radius: 999px;
  background: linear-gradient(135deg, var(--jedi-pink), var(--jedi-blue));
  box-shadow: 0 0 18px rgba(92, 198, 208, 0.55);
  animation: victoryPanelRankingOrbPulse 1.2s ease-in-out infinite;
}

.victory-ranking-loading-orb:nth-child(2) {
  animation-delay: 0.15s;
}

.victory-ranking-loading-orb:nth-child(3) {
  animation-delay: 0.3s;
}

.victory-ranking-loading-skeleton {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.victory-ranking-loading-row {
  height: 46px;
  border-radius: 16px;
  background:
    linear-gradient(90deg, rgba(105, 41, 252, 0.08), rgba(92, 198, 208, 0.22), rgba(105, 41, 252, 0.08));
  background-size: 220% 100%;
  animation: victoryPanelRankingShimmer 1.8s linear infinite;
}

.victory-ranking-error {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 22px 18px;
  text-align: center;
}

.victory-ranking-error-title {
  margin: 0;
  color: #be123c;
  font-size: 1.1rem;
  font-weight: 900;
}

.victory-ranking-error-text {
  margin: 0;
  color: #475569;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.4;
}

@keyframes victoryPanelSlideIn {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes victoryPanelImageBounce {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-10px);
  }
}

@keyframes victoryPanelTitlePulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes victoryPanelRankingOrbPulse {
  0%, 100% {
    transform: translateY(0) scale(0.95);
    opacity: 0.5;
  }
  50% {
    transform: translateY(-4px) scale(1.12);
    opacity: 1;
  }
}

@keyframes victoryPanelRankingShimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

@media screen and (max-width: 1024px) {
  .victory-panel-shell {
    width: 90dvw;
    height: 80dvh;
  }

  .victory-panel-card {
    grid-template-columns: minmax(240px, 0.88fr) minmax(320px, 1.12fr);
    padding: 20px;
    gap: 18px;
  }

  .victory-panel-image {
    width: min(20vw, 200px);
  }

  .victory-panel-image-wrap {
    height: 25%;
  }

}

@media screen and (max-width: 768px) {
  .victory-panel-shell {
    width: 95dvw;
    height: 85dvh;
  }

  .victory-panel-card {
    grid-template-columns: 1fr;
    grid-template-rows: auto minmax(0, 1fr);
    padding: 16px;
    gap: 14px;
  }

  .victory-panel-left {
    padding: 12px 16px;
  }

  .victory-panel-image {
    width: min(24vw, 150px);
  }

  .victory-panel-subtitle {
    max-width: 28ch;
    margin-bottom: 14px;
  }

  .victory-panel-restart-button {
    padding: 12px 28px;
  }

  .victory-panel-shell {
    height: 95dvh;
    width: 95dvw;
    padding: 20px;    
  }
  .victory-panel-left {
    width: 40%;
  }
  .victory-panel-image-wrap {
    height: 20%;
  }

  .victory-panel-card {
    display: flex;    
  }
}

@media screen and (max-width: 480px) {
  .victory-panel-shell {
    width: 100dvw;
    height: 90dvh;
  }

  .victory-panel-card {
    padding: 12px;
    border-radius: 22px;
  }

  .victory-panel-left,
  .victory-ranking {
    border-radius: 18px;
  }

}
`, "",{"version":3,"sources":["webpack://./src/components/VictoryPanel.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kEAAkE;EAClE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C;;kFAEgF;EAChF;;2CAEyC;EACzC,4CAA4C;EAC5C,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB;;6EAE2E;EAC3E,oDAAoD;EACpD,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oEAAoE;AACtE;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,4CAA4C;EAC5C,2DAA2D;AAC7D;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,+CAA+C;EAC/C,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,sFAAsF;EACtF,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,yBAAyB;EACzB;IACE,yBAAyB;IACzB,WAAW;EACb;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,sFAAsF;EACtF;;2CAEyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;EACtB;;2CAEyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,YAAY;EACZ,aAAa;AACf;;;;;;oBAMoB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,yBAAyB;EACzB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,sEAAsE;EACtE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gEAAgE;EAChE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kDAAkD;EAClD,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;8EAC4E;EAC5E;;4CAE0C;AAC5C;;AAEA;EACE;8EAC4E;AAC9E;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gEAAgE;EAChE,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,qHAAqH;AACrH;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,gCAAgC;AAClC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,gDAAgD;EAChD;;6CAE2C;AAC7C;;AAEA,mDAAmD;AACnD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC;;sCAEoC;EACpC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,uEAAuE;EACvE,6CAA6C;EAC7C,gEAAgE;AAClE;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB;wGACsG;EACtG,0BAA0B;EAC1B,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,oCAAoC;IACpC,YAAY;EACd;EACA;IACE,uCAAuC;IACvC,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kEAAkE;IAClE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;AAEF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,uCAAuC;IACvC,aAAa;IACb,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;IACb,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;AAEF","sourcesContent":[".victory-panel-shell {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 65dvw;\r\n  height: 80dvh;\r\n  transform: translate(-50%, -50%);\r\n  z-index: 9000;\r\n  pointer-events: auto;\r\n}\r\n\r\n.victory-panel-card {\r\n  position: relative;\r\n  display: grid;\r\n  grid-template-columns: minmax(280px, 0.92fr) minmax(360px, 1.18fr);\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 24px;\r\n  border-radius: 30px;\r\n  border: 5px solid rgba(255, 255, 255, 0.28);\r\n  background:\r\n    linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(235, 240, 255, 0.94)),\r\n    radial-gradient(circle at top left, rgba(92, 198, 208, 0.18), transparent 34%);\r\n  box-shadow:\r\n    0 24px 60px rgba(0, 0, 0, 0.5),\r\n    inset 0 1px 0 rgba(255, 255, 255, 0.65);\r\n  animation: victoryPanelSlideIn 0.8s ease-out;\r\n  gap: 24px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.victory-panel-left {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 16px 18px;\r\n  border-radius: 24px;\r\n  background:\r\n    linear-gradient(180deg, rgba(255, 255, 255, 0.92), rgba(239, 244, 255, 0.82)),\r\n    radial-gradient(circle at top, rgba(236, 98, 255, 0.12), transparent 40%);\r\n  box-shadow: inset 0 0 0 1px rgba(105, 41, 252, 0.08);\r\n  min-width: 0;\r\n}\r\n\r\n.victory-panel-image-wrap {\r\n  margin-bottom: 18px;\r\n  animation: victoryPanelImageBounce 1s ease-in-out infinite alternate;\r\n}\r\n\r\n.victory-panel-image {\r\n  /* width: min(18vw, 250px); */\r\n  min-width: 120px;\r\n  height: auto;\r\n  display: block;\r\n  filter: drop-shadow(0 12px 24px rgba(0, 0, 0, 0.3));\r\n}\r\n\r\n.victory-panel-title {\r\n  margin: 10px 0 16px;\r\n  color: var(--jedi-violet);\r\n  font-size: clamp(2rem, 3.5vw, 4rem);\r\n  font-weight: 900;\r\n  line-height: 1;\r\n  text-align: center;\r\n  text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.28);\r\n  animation: victoryPanelTitlePulse 1.5s ease-in-out infinite;\r\n}\r\n\r\n.victory-panel-subtitle {\r\n  max-width: 18ch;\r\n  margin: 0 0 18px;\r\n  color: #334155;\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  line-height: 1.35;\r\n  text-align: center;\r\n}\r\n\r\n.victory-panel-ranking-type {\r\n  color: var(--jedi-violet);\r\n  font-size: 1.0rem;\r\n  font-weight: 700;\r\n  font-family: Comic Sans MS, Comic Sans, cursive;\r\n  line-height: 1.35;\r\n  text-align: center;\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 10px;\r\n  margin-bottom: 18px;\r\n  background: linear-gradient(180deg, var(--jedi-green) 0%, var(--jedi-dark-green) 150%);\r\n  padding: 10px;\r\n  border-radius: 10px;\r\n  border: 1px solid #647e0d;\r\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\r\n  transition: all 0.3s ease;\r\n  &:hover {\r\n    background-color: #647e0d;\r\n    color: #fff;\r\n  }\r\n}\r\n\r\n.victory-panel-restart-button {\r\n  margin-top: 12px;\r\n  padding: 18px 42px;\r\n  border: none;\r\n  border-radius: 999px;\r\n  color: #fff;\r\n  font-size: clamp(1rem, 1.6vw, 1.35rem);\r\n  font-weight: 800;\r\n  cursor: pointer;\r\n  background: linear-gradient(135deg, var(--jedi-green) 0%, var(--jedi-dark-green) 100%);\r\n  box-shadow:\r\n    0 10px 30px rgba(0, 0, 0, 0.22),\r\n    inset 0 1px 0 rgba(255, 255, 255, 0.28);\r\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n\r\n.victory-panel-restart-button:hover {\r\n  transform: scale(1.05);\r\n  box-shadow:\r\n    0 14px 36px rgba(0, 0, 0, 0.28),\r\n    inset 0 1px 0 rgba(255, 255, 255, 0.28);\r\n}\r\n\r\n.victory-panel-restart-button:active {\r\n  transform: scale(0.97);\r\n}\r\n\r\n.victory-ranking {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  min-width: 0;\r\n  min-height: 0;\r\n/*  border-radius: 24px;\r\n  padding: 18px 18px 14px;\r\n  background: linear-gradient(180deg, rgba(248, 250, 255, 0.96), rgba(237, 242, 255, 0.94));\r\n  box-shadow:\r\n    inset 0 0 0 1px rgba(92, 198, 208, 0.18),\r\n    0 10px 24px rgba(54, 78, 135, 0.08);\r\n  overflow: hidden;*/\r\n}\r\n\r\n.victory-ranking-scale-shell {\r\n  position: relative;\r\n  flex: 1;\r\n  min-width: 0;\r\n  min-height: 0;\r\n}\r\n\r\n.victory-ranking-scale-stage {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 620px;\r\n  height: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  transform-origin: center center;\r\n}\r\n\r\n.victory-ranking-header {\r\n  flex-shrink: 0;\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.victory-ranking-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin: 0;\r\n  color: var(--jedi-violet);\r\n  font-size: clamp(1.4rem, 2vw, 2rem);\r\n  font-weight: 900;\r\n}\r\n\r\n.victory-ranking-title-icon {\r\n  font-size: 1.1em;\r\n  line-height: 1;\r\n}\r\n\r\n.victory-ranking-accent {\r\n  width: 84px;\r\n  height: 6px;\r\n  margin-top: 10px;\r\n  border-radius: 999px;\r\n  background: linear-gradient(90deg, var(--jedi-pink), var(--jedi-blue));\r\n  box-shadow: 0 0 12px rgba(236, 98, 255, 0.32);\r\n}\r\n\r\n.victory-ranking-board {\r\n  display: flex;\r\n  flex: 1;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  border-radius: 22px;\r\n  overflow: hidden;\r\n  background: rgba(255, 255, 255, 0.6);\r\n  border: 2px solid rgba(105, 41, 252, 0.08);\r\n}\r\n\r\n.victory-ranking-grid {\r\n  display: grid;\r\n  grid-template-columns: 6fr 6fr 30fr 9fr;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.victory-ranking-head {\r\n  padding: 14px 16px;\r\n  color: white;\r\n  background: linear-gradient(135deg, var(--jedi-violet), #4c1ab1);\r\n  font-size: 1.5rem;\r\n  font-weight: 800;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.08em;\r\n  box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.14);\r\n}\r\n\r\n.victory-ranking-body {\r\n  min-height: 0;\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 6px 8px;\r\n}\r\n\r\n.victory-ranking-body::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.victory-ranking-body::-webkit-scrollbar-track {\r\n  background: rgba(105, 41, 252, 0.08);\r\n  border-radius: 999px;\r\n}\r\n\r\n.victory-ranking-body::-webkit-scrollbar-thumb {\r\n  background: rgba(105, 41, 252, 0.46);\r\n  border-radius: 999px;\r\n}\r\n\r\n.victory-ranking-row {\r\n  padding: 10px 8px;\r\n  color: #334155;\r\n  border-bottom: 1px solid rgba(148, 163, 184, 0.18);\r\n  transition: background-color 0.15s ease;\r\n}\r\n\r\n.victory-ranking-row:hover {\r\n  background: rgba(255, 255, 255, 0.78);\r\n}\r\n\r\n.victory-ranking-row.is-top-three .victory-ranking-position {\r\n  color: var(--jedi-violet);\r\n  font-weight: 900;\r\n}\r\n\r\n.victory-ranking-row.is-current-player-duplicate {\r\n  background:\r\n    linear-gradient(90deg, rgba(196, 222, 29, 0.16), rgba(92, 198, 208, 0.08));\r\n  box-shadow:\r\n    inset 4px 0 0 rgba(196, 222, 29, 0.9),\r\n    inset 0 0 0 1px rgba(196, 222, 29, 0.18);\r\n}\r\n\r\n.victory-ranking-row.is-current-player-duplicate:hover {\r\n  background:\r\n    linear-gradient(90deg, rgba(196, 222, 29, 0.22), rgba(92, 198, 208, 0.12));\r\n}\r\n\r\n.victory-ranking-row.is-placeholder {\r\n  color: #94a3b8;\r\n  font-style: italic;\r\n}\r\n\r\n.victory-ranking-row.is-placeholder:hover {\r\n  background: transparent;\r\n}\r\n\r\n.victory-ranking-player-row {\r\n  padding: 12px 16px;\r\n  color: white;\r\n  background: linear-gradient(135deg, var(--jedi-violet), #4c1ab1);\r\n  box-shadow: 0 -6px 18px rgba(76, 26, 177, 0.18);\r\n}\r\n\r\n.victory-ranking-cell-center {\r\n  text-align: center;\r\n}\r\n\r\n.victory-ranking-cell-score {\r\n  text-align: right;\r\n  font-weight: 900;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.victory-ranking-position {\r\n  font-size: 1.8rem;\r\n  font-weight: 800;\r\n}\r\n\r\n.victory-ranking-name {\r\n  display: grid;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-weight: 800;\r\n  font-size: 1.8rem;\r\n  line-height: 1.2;\r\n}\r\n\r\n/* Linha 1: nome + etiqueta da turma (+ \"você\") */\r\n.victory-ranking-name-main {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  min-width: 0;\r\n}\r\n\r\n.victory-ranking-name-text {\r\n  flex: none;\r\n  max-width: 100%;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n/* Turma em etiqueta: textos longos (ex.: \"NEM EPT IF TEC...\") são cortados só aqui; o texto completo fica no title */\r\n.victory-ranking-turma {\r\n  min-width: 0;\r\n  max-width: 11em;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  padding: 1px 9px;\r\n  border-radius: 999px;\r\n  background: rgba(92, 198, 208, 0.18);\r\n  color: #0e6670;\r\n  font-size: 0.95rem;\r\n  font-weight: 700;\r\n}\r\n\r\n/* Linha 2: apelido · escola */\r\n.victory-ranking-name-sub {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  font-size: 1.05rem;\r\n  font-weight: 600;\r\n  color: #64748b;\r\n}\r\n\r\n.victory-ranking-player-row .victory-ranking-turma {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  color: #fff;\r\n}\r\n\r\n.victory-ranking-player-row .victory-ranking-name-sub {\r\n  color: rgba(255, 255, 255, 0.82);\r\n}\r\n\r\n.victory-ranking-name-main .victory-ranking-player-label {\r\n  flex: none;\r\n  margin-left: 0;\r\n}\r\n\r\n.victory-ranking-player-label {\r\n  margin-left: 8px;\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.04em;\r\n  text-transform: uppercase;\r\n  opacity: 0.92;\r\n}\r\n\r\n.victory-ranking-avatar-wrap {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.victory-ranking-avatar-button {\r\n  padding: 0;\r\n  border: none;\r\n  background: transparent;\r\n  border-radius: 999px;\r\n  cursor: pointer;\r\n  transition: transform 0.15s ease;\r\n}\r\n\r\n.victory-ranking-avatar-button:hover,\r\n.victory-ranking-avatar-button:focus-visible {\r\n  transform: scale(1.06);\r\n}\r\n\r\n.victory-ranking-avatar-button:focus-visible {\r\n  outline: 3px solid rgba(92, 198, 208, 0.5);\r\n  outline-offset: 2px;\r\n}\r\n\r\n.victory-ranking-avatar {\r\n  width: 40px;\r\n  height: 40px;\r\n  object-fit: cover;\r\n  border-radius: 999px;\r\n  /* border: 2px solid rgba(92, 198, 208, 0.82); */\r\n  box-shadow:\r\n    0 4px 12px rgba(0, 0, 0, 0.14),\r\n    inset 0 0 0 1px rgba(255, 255, 255, 0.24);\r\n}\r\n\r\n/* Avatar que não carregou: círculo com a inicial */\r\n.victory-ranking-avatar-fallback {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: linear-gradient(135deg, #7c3aed 0%, #5cc6d0 100%);\r\n  color: #fff;\r\n  font-weight: bold;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.victory-panel-avatar-overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  z-index: 30;\r\n  pointer-events: none;\r\n  opacity: 0;\r\n  transition: opacity 0.15s ease;\r\n}\r\n\r\n.victory-panel-avatar-overlay.is-visible {\r\n  opacity: 1;\r\n}\r\n\r\n.victory-panel-avatar-overlay-backdrop {\r\n  position: absolute;\r\n  inset: 0;\r\n  background: rgba(15, 23, 42, 0.18);\r\n  backdrop-filter: blur(1.5px);\r\n}\r\n\r\n.victory-panel-avatar-overlay-content {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n.victory-panel-avatar-overlay-card {\r\n  width: clamp(180px, 18vw, 250px);\r\n  aspect-ratio: 752 / 926;\r\n  overflow: hidden;\r\n  border: 4px solid rgba(255, 255, 255, 0.9);\r\n  border-radius: 18px;\r\n  background: rgba(255, 255, 255, 0.96);\r\n  box-shadow:\r\n    0 24px 80px rgba(0, 0, 0, 0.45),\r\n    0 0 0 1px rgba(226, 232, 240, 0.8);\r\n  padding: 8px;\r\n}\r\n\r\n.victory-panel-avatar-overlay-image {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: block;\r\n  object-fit: contain;\r\n  border-radius: 12px;\r\n}\r\n\r\n.victory-ranking-player-row .victory-ranking-avatar {\r\n  border-color: rgba(255, 255, 255, 0.95);\r\n}\r\n\r\n.victory-ranking-loading {\r\n  display: flex;\r\n  flex: 1;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  gap: 16px;\r\n  padding: 18px 12px;\r\n}\r\n\r\n.victory-ranking-loading-text {\r\n  color: var(--jedi-violet);\r\n  font-size: 1rem;\r\n  font-weight: 900;\r\n  text-align: center;\r\n}\r\n\r\n.victory-ranking-loading-orbs {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 12px;\r\n}\r\n\r\n.victory-ranking-loading-orb {\r\n  width: 14px;\r\n  height: 14px;\r\n  border-radius: 999px;\r\n  background: linear-gradient(135deg, var(--jedi-pink), var(--jedi-blue));\r\n  box-shadow: 0 0 18px rgba(92, 198, 208, 0.55);\r\n  animation: victoryPanelRankingOrbPulse 1.2s ease-in-out infinite;\r\n}\r\n\r\n.victory-ranking-loading-orb:nth-child(2) {\r\n  animation-delay: 0.15s;\r\n}\r\n\r\n.victory-ranking-loading-orb:nth-child(3) {\r\n  animation-delay: 0.3s;\r\n}\r\n\r\n.victory-ranking-loading-skeleton {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.victory-ranking-loading-row {\r\n  height: 46px;\r\n  border-radius: 16px;\r\n  background:\r\n    linear-gradient(90deg, rgba(105, 41, 252, 0.08), rgba(92, 198, 208, 0.22), rgba(105, 41, 252, 0.08));\r\n  background-size: 220% 100%;\r\n  animation: victoryPanelRankingShimmer 1.8s linear infinite;\r\n}\r\n\r\n.victory-ranking-error {\r\n  display: flex;\r\n  flex: 1;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  padding: 22px 18px;\r\n  text-align: center;\r\n}\r\n\r\n.victory-ranking-error-title {\r\n  margin: 0;\r\n  color: #be123c;\r\n  font-size: 1.1rem;\r\n  font-weight: 900;\r\n}\r\n\r\n.victory-ranking-error-text {\r\n  margin: 0;\r\n  color: #475569;\r\n  font-size: 0.95rem;\r\n  font-weight: 700;\r\n  line-height: 1.4;\r\n}\r\n\r\n@keyframes victoryPanelSlideIn {\r\n  0% {\r\n    opacity: 0;\r\n    transform: scale(0.5);\r\n  }\r\n  50% {\r\n    transform: scale(1.05);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n@keyframes victoryPanelImageBounce {\r\n  0% {\r\n    transform: translateY(0);\r\n  }\r\n  100% {\r\n    transform: translateY(-10px);\r\n  }\r\n}\r\n\r\n@keyframes victoryPanelTitlePulse {\r\n  0%, 100% {\r\n    transform: scale(1);\r\n  }\r\n  50% {\r\n    transform: scale(1.05);\r\n  }\r\n}\r\n\r\n@keyframes victoryPanelRankingOrbPulse {\r\n  0%, 100% {\r\n    transform: translateY(0) scale(0.95);\r\n    opacity: 0.5;\r\n  }\r\n  50% {\r\n    transform: translateY(-4px) scale(1.12);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes victoryPanelRankingShimmer {\r\n  0% {\r\n    background-position: 200% 0;\r\n  }\r\n  100% {\r\n    background-position: -200% 0;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1024px) {\r\n  .victory-panel-shell {\r\n    width: 90dvw;\r\n    height: 80dvh;\r\n  }\r\n\r\n  .victory-panel-card {\r\n    grid-template-columns: minmax(240px, 0.88fr) minmax(320px, 1.12fr);\r\n    padding: 20px;\r\n    gap: 18px;\r\n  }\r\n\r\n  .victory-panel-image {\r\n    width: min(20vw, 200px);\r\n  }\r\n\r\n  .victory-panel-image-wrap {\r\n    height: 25%;\r\n  }\r\n\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .victory-panel-shell {\r\n    width: 95dvw;\r\n    height: 85dvh;\r\n  }\r\n\r\n  .victory-panel-card {\r\n    grid-template-columns: 1fr;\r\n    grid-template-rows: auto minmax(0, 1fr);\r\n    padding: 16px;\r\n    gap: 14px;\r\n  }\r\n\r\n  .victory-panel-left {\r\n    padding: 12px 16px;\r\n  }\r\n\r\n  .victory-panel-image {\r\n    width: min(24vw, 150px);\r\n  }\r\n\r\n  .victory-panel-subtitle {\r\n    max-width: 28ch;\r\n    margin-bottom: 14px;\r\n  }\r\n\r\n  .victory-panel-restart-button {\r\n    padding: 12px 28px;\r\n  }\r\n\r\n  .victory-panel-shell {\r\n    height: 95dvh;\r\n    width: 95dvw;\r\n    padding: 20px;    \r\n  }\r\n  .victory-panel-left {\r\n    width: 40%;\r\n  }\r\n  .victory-panel-image-wrap {\r\n    height: 20%;\r\n  }\r\n\r\n  .victory-panel-card {\r\n    display: flex;    \r\n  }\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n  .victory-panel-shell {\r\n    width: 100dvw;\r\n    height: 90dvh;\r\n  }\r\n\r\n  .victory-panel-card {\r\n    padding: 12px;\r\n    border-radius: 22px;\r\n  }\r\n\r\n  .victory-panel-left,\r\n  .victory-ranking {\r\n    border-radius: 18px;\r\n  }\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
